import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import { Scrollbar } from "swiper";
import { getPartnerLogo } from "../../redux/slices/common";
import { useSelector, useDispatch } from "react-redux";

const Brand2 = () => {
  const dispatch = useDispatch();
  const [fleetCard, setFleetCard] = useState([]);
  const { partnerLogo } = useSelector((state) => state.common);
 
  useEffect(() => {
    if (partnerLogo) {
      setFleetCard(partnerLogo?.ourPartners);
    }
  }, [partnerLogo]);

  useEffect(() => {
    dispatch(getPartnerLogo());
  }, []);

  //  const swiperRef = useRef(null);

  return (
    <section
    className="section-bg layout-pb-md md:pt-40 md:pb-40 "
    data-aos="fade-up">
    <div className="brand-slider">
      <Swiper
        spaceBetween={30}
        className="overflow-hidden"
        // scrollbar={{
        //   el: ".js-popular-destination-scrollbar",
        //   draggable: true,
        //   autoplay: true,
        // }}
        autoplay={true}
        modules={[Navigation, Autoplay]}
        navigation={{
          nextEl: ".js-destination-next",
          prevEl: ".js-destination-prev",
        }}
        breakpoints={{
          300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          500: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
          1024: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
      >
        {Array.isArray(fleetCard) &&
          fleetCard.map((item, index) => (
            <SwiperSlide key={item.id || index}>
              <div
                className="citiesCard -type-1 d-block rounded-4"
                key={item.id}
              >
                <div className="citiesCard__image ratio ratio-1:1">
                  <img
                    // src={`/img/clients/${item}.png`}
                    src={`${process.env.IMAGE_BASE_URL}/${item.image}`}
                    style={{
                      // width: "160px",
                      aspectRatio: "3/2",
                      objectFit: "contain",
                    }}
                    alt="brands"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>

      <div className="z-5">
        <button className="section-slider-navbar z-5 -prev flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-destination-prev">
          <i className="icon icon-chevron-left text-12" />
        </button>
        <button className="section-slider-navbar2 z-5 -next flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-destination-next">
          <i className="icon icon-chevron-right text-12" />
        </button>
      </div>
    </div>
    </section>
  );
};

export default Brand2;